export default {
  header: 'Choose Menu',
};
